
import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { getToken } from './'

const Auth = {
	isAuthenticated: () => {
		const token = getToken()
		return !!token
	}
}

const PrivateRoute = ({ component: Component, ...rest, browserHistory }) => (
	<Route {...rest} render={(props) => {
		if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
			return <Redirect to='/login' />
		}

		if (Component !== undefined) {
			return <Component {...props} />
		} else {
			return <Redirect to='/' />
		}
	}} browserHistory={browserHistory} />
)

const PublicRoute = ({ component: Component, ...rest }) => {
	return <Route {...rest} render={(props) => {

		if (Auth.isAuthenticated() === true && props.match.url === "/login") {
			return <Redirect to='/' />
		}

		if (Component !== undefined) {
			return <Component {...props} />
		} else {
			return ""
		}
	}} />
}

export {
	PrivateRoute,
	PublicRoute,
	Auth,
}


// WEBPACK FOOTER //
// ./src/lib/routePermission.js